
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.667 11.7l-1.18 1.147a1.65 1.65 0 01-2.334-2.333L6.18 7.48a1.64 1.64 0 012.26-.06l.08.067a.667.667 0 00.933-.953 1.836 1.836 0 00-.12-.14 2.973 2.973 0 00-4.06.146L2.207 9.574a2.987 2.987 0 004.22 4.22l1.153-1.127a.667.667 0 00-.913-.967zm7.126-9.493a2.993 2.993 0 00-4.22 0L8.42 3.334a.667.667 0 00.913.966l1.154-1.146a1.65 1.65 0 012.333 2.333L9.793 8.52a1.64 1.64 0 01-2.26.06l-.08-.066a.667.667 0 00-.933.953 2.98 2.98 0 004.213-.007l3.034-3.033a2.993 2.993 0 00.026-4.22z","fill":"currentColor"}})])
          )
        }
      }
    